// `#<questionId>` links scroll to and highlight a question on load (useHashScrollOnMount).
export const buildQuestionHash = (questionId: string) => `#${questionId}`
